import { Action } from 'redux';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { SetTags } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SetTagsAction extends Action {
  content: IContentInfo[];
}

export function setTags(...content: IContentInfo[]): SetTagsAction {
  return {
    type: SetTags,
    content: content
  };
}

export const isSetTagsAction = isActionFactory<SetTagsAction>(SetTags);
